module.exports = __webpack_public_path__ + "img/07.2d26b9fc.png";